module.exports = __webpack_public_path__ + "img/inflation-lock-white.db189b4f.svg";